/** Resolve display/storage name across hotel_name / company_name schema drift. */
export function resolveHotelDetailName(row: {
  company_name?: string | null;
  hotel_name?: string | null;
}): string {
  return (row.company_name ?? row.hotel_name ?? "").trim();
}

/** Payload fields to keep company_name and hotel_name aligned on upsert. */
export function withSyncedHotelDetailName(
  hotelName: string,
): { company_name: string; hotel_name: string } {
  const name = hotelName.trim();
  return { company_name: name, hotel_name: name };
}
